import React from 'react';

import telegramSvg from '@assets/telegram_big.svg';
import { Section } from '@components/Common';
import env from '@config/env';
import { useText } from '@hooks/useText';
import { Button, Typography } from '@material-tailwind/react';

interface TelegramSubscriptionProps {
  onSubscribeHandler: () => void;
}

const TelegramSubscription: React.FC<TelegramSubscriptionProps> = ({ onSubscribeHandler }) => {
    const { t } = useText();
    return (
    <div className="flex justify-center">
        <Section className="max-w-2xl" contentClassName="flex items-center flex-col">
            <div className="py-10">
                <img className="w-[100px] h-[100px]" src={telegramSvg} alt="Telegram icon" />
            </div>
            <Typography variant="h3" className="mb-3">
                {t('telegramBotSubscribe.title')}
            </Typography>
            <Typography variant="paragraph" className="font-medium text-center mb-6">
                {t('telegramBotSubscribe.description')}                
            </Typography>
            <a
                href={env.TELEGRAM_BOT_LINK}
                target="_blank"
                rel="noopener noreferrer"
            >
            <Button onClick={onSubscribeHandler}>
                {t('telegramBotSubscribe.button')} {env.TELEGRAM_BOT_NAME}
            </Button>
            </a>
        </Section>
    </div>
    );
};

export default TelegramSubscription;